export const send = (name: string, params?: any) => {
  // @ts-ignore
  window._faq?.push([
    'trackEvent',
    name,
    {
      $ts: new Date().getTime(),
      ...params,
    },
  ]);
};
